module.exports = __webpack_public_path__ + "videos/main-banner.1d5c58d.mp4";